export default __webpack_public_path__ + "static/media/yellow-taxes.40b9c9ec.svg";